import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
export const OverlappingIcons = ({
  icons = [],
  wrapperSize = '20px'
}) => {
  if (icons.length === 0) return null;
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    children: icons.map((icon, index) => /*#__PURE__*/_jsx(Flex, {
      inlineSize: wrapperSize,
      blockSize: wrapperSize,
      borderRadius: "full",
      backgroundColor: "fill-accent-neutral-subtle-alt",
      alignItems: "center",
      justifyContent: "center",
      marginInlineStart: index === 0 ? '0' : '-100',
      borderColor: "border-core-on-fill-default",
      borderWidth: "100",
      borderStyle: "solid",
      overflow: "hidden",
      children: icon
    }, index))
  });
};
export default OverlappingIcons;